/**
 * @typedef {Object} PushConfiguration
 * @property {boolean}          startImmediately            - <code>true</code> to start pushing immediately,
 *                                                            otherwise <code>false</code>.
 * @property {Function}         sioClient                   - The "socket.io" client object.
 * @property {Object}           sioClientOptions            - Options for the "socket.io" client.
 * @property {string|undefined} pushUrl                     - <code>undefined</code> means <code>window.location</code>.
 * @property {Function}         getThrottlingIntervalInMs   - {@link BootstrapConfig#getPushThrottlingIntervalInMs}
 */

/**
 * @type {PushConfiguration}
 */
export class DefaultPushConfiguration {
    constructor() {
        this.startImmediately = true
        this.sioClient = window.io
        this.pushUrl = undefined
        this.sioClientOptions = {
            // [MODUX-87] Restrict transports as long polling does not work with ATAPI cluster manager
            transports: ['websocket']
        }
        this.getThrottlingIntervalInMs = () => 10000
    }
}
